import { render } from "./TemaMateriale.vue?vue&type=template&id=1f171d88"
import script from "./TemaMateriale.vue?vue&type=script&lang=js"
export * from "./TemaMateriale.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__